import {
  Card as MuiCard,
  CardActions,
  CardContent,
  CardProps
} from '@mui/material';
import { styled } from '@mui/material/styles';

interface CardPropsI extends CardProps {
  selected?: boolean;
  content: React.ReactNode;
  action?: React.ReactNode;
  handleClick?: (event: React.MouseEvent) => void;
  height?: number;
  width?: number;
  padding?: string;
  currentPlan?: boolean;
  colorBorder?: string;
  alignItems?: string;
}

const Card = styled(MuiCard)<CardPropsI>(
  ({
    height,
    width,
    selected,
    action,
    theme,
    padding,
    currentPlan,
    colorBorder,
    alignItems
  }) => ({
    height: height ?? '16.5rem',
    width: width ?? '16.5rem',
    borderRadius: '16px',
    boxSizing: 'border-box',
    backgroundColor: '#FFFFFF',
    textAlign: 'center',
    border: selected
      ? `2px solid ${theme.palette.primary.main}`
      : currentPlan
      ? `2px solid #FFE233`
      : colorBorder
      ? `2px solid ${colorBorder}`
      : '2px solid transparent',
    padding: padding ?? '1.5rem',
    justifyContent: 'space-between',
    boxShadow: 'none',

    '& > .MuiCardContent-root': {
      display: 'flex',
      alignItems: alignItems ?? 'stretch',
      justifyContent: 'center',
      height: action && height ? `calc(${height}px/2)` : '8rem'
    },

    '& > .MuiCardActions-root': {
      padding: '0'
    }
  })
);

export default function StyledCard(props: CardPropsI) {
  return (
    <Card {...props}>
      {props.content && <CardContent>{props.content}</CardContent>}
      {props.action && <CardActions>{props.action}</CardActions>}
    </Card>
  );
}
